// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import BidMapController from "./bid_map_controller"
application.register("bid-map", BidMapController)

import CheckAllController from "./check_all_controller"
application.register("check-all", CheckAllController)

import CommentObserverController from "./comment_observer_controller"
application.register("comment-observer", CommentObserverController)

import InputMimicController from "./input_mimic_controller"
application.register("input-mimic", InputMimicController)

import PhoneMaskController from "./phone_mask_controller"
application.register("phone-mask", PhoneMaskController)

import ProtocolFormController from "./protocol_form_controller"
application.register("protocol-form", ProtocolFormController)

import SealFieldController from "./seal_field_controller"
application.register("seal-field", SealFieldController)

import SvelteController from "./svelte_controller"
application.register("svelte", SvelteController)
